import Vue from 'vue'
import Popover from 'vue-js-popover'
import VueMeta from 'vue-meta';
Vue.use(Popover)
Vue.use(VueMeta)